// extracted by mini-css-extract-plugin
export default {"fileBlock":"FileLabel_fileBlock__Tj3ws","fileIcon":"FileLabel_fileIcon__ZRqLH","deleteIcon":"FileLabel_deleteIcon__+4D4r"};